import { timeStringToNumber as n } from "./timeStringToNumber.js";
const u = (t, o = 0.8, i = 240) => {
  var r;
  return t ? n(
    ((r = window.getComputedStyle(t, null)) == null ? void 0 : r.getPropertyValue("transition-duration")) || ".3s"
  ) * o : i;
};
export {
  u as getTransitionDuration
};
